// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G8Gi","colMin":"styles_colMin__30Kzw"};